module.exports = "/images/14K-YG.webp?8451c9a1519ab5486700e2dcd5aa6eac";